import React from "react";

import SideMenu from "../../../components/SideMenu";
import Footer from "../../../components/Footer";
import Quotes from "../../../components/Quotes";

import PixTransfer from "../../../components/Transactions/Pix/Transfer";
import AccountManagerService from "../../../services/Celcoin/accountManagerService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeysManagementService from "../../../services/Celcoin/keysManagementService";
import { getTranslations } from "../../../services/languageUtils";
import { isMutual } from "../../../utils/isMutual";
import { isMtBank } from "../../../utils/isMtBank";
import { isVoluti } from "../../../utils/isVoluti";

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "pixTransfer",
      step: 0,
      valueBalance: 0.0,
      viewBalance: false,
      translations: {},
      pixKey: "",
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
    this.getBalance();
    this.updateKeys();

    const params = new URLSearchParams(window.location.search);
    const type = params.get("type");
    if (type) {
      this.setState({ type, step: 0 });
    }
  }

  getBalance() {
    const that = this;
    AccountManagerService.showBalance()
      .then((res) => {
        that.setState({ valueBalance: res.data.body.amount });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  updateKeys() {
    let that = this;
    KeysManagementService.index()
      .then((res) => {
        const keys = Array.isArray(res?.data)
          ? res.data
          : res?.data?.body?.listKeys || [];
        const firstKey = keys[0]?.key || "";
        that.setState({ pixKey: firstKey });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  onChangeValue = (event) => {
    switch (event.target.name) {
      case "step":
        this.setState({ step: event.target.value });
        break;

      default:
        break;
    }
  };

  copyPixKey = () => {
    const { pixKey } = this.state;
    if (!pixKey) return;

    navigator.clipboard
      .writeText(pixKey)
      .then(() => {
        toast("Chave copiada com sucesso!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
          theme: "light",
        });
      })
      .catch((err) => {
        console.error("Erro ao copiar chave PIX:", err);
      });
  };

  render() {
    return (
      <section id="userPage" className="userPage transactionPage">
        <SideMenu />

        <span className="desktop">
          <div className="contentData">
            <div className="contentScroll">
              <Quotes />
              <p className="breadcrumb">
                <b>
                  <span className="textPrimary">
                    {this.state.translations.home} |{" "}
                    {this.state.translations.transfers}
                  </span>{" "}
                  | {this.state.translations.pix}
                </b>
              </p>
              <br />
              <p className="title">
                <span style={{ fontWeight: "normal" }}>
                  {this.state.translations.transfers} |
                </span>{" "}
                {this.state.translations.pix}
                {this.state.pixKey && (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "14px",
                    }}
                  >
                    <b>&nbsp;&nbsp;&nbsp;&nbsp;CHAVE PIX:</b>{" "}
                    {this.state.pixKey}
                    <button
                      onClick={this.copyPixKey}
                      style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        padding: "4px",
                      }}
                      title="Copiar chave PIX"
                    >
                      <img
                        src={
                          require("../../../assets/imgs/ico-copy-paste.svg")
                            .default
                        }
                        alt="Copiar"
                        style={{
                          width: "18px",
                          height: "18px",
                          filter:
                            "invert(55%) sepia(69%) saturate(433%) hue-rotate(77deg) brightness(92%) contrast(92%)",
                        }}
                      />
                    </button>
                  </span>
                )}
              </p>
              <br />

              <div className="contentSubData">
                <div
                  className={
                    "contentButtonPix " +
                    (this.state.type === "pixTransfer"
                      ? "contentButtonPixSelected"
                      : "")
                  }
                  onClick={() => {
                    this.setState({ type: "pixTransfer", step: 0 });
                  }}
                >
                  {this.state.type === "pixTransfer" && (
                    <img
                      src={
                        require("../../../assets/imgs/ico-transfer-white.svg")
                          .default
                      }
                      alt={this.state.translations.iconMenu}
                      className="iconPix"
                    />
                  )}
                  {this.state.type !== "pixTransfer" && (
                    <img
                      src={
                        require("../../../assets/imgs/ico-transfer-green.svg")
                          .default
                      }
                      alt={this.state.translations.iconMenu}
                      className="iconPix"
                    />
                  )}
                  {this.state.translations.pixTransfer}
                </div>

                {isMtBank() && (
                  <div
                    className={
                      "contentButtonPix " +
                      (this.state.type === "batch"
                        ? "contentButtonPixSelected"
                        : "")
                    }
                    onClick={() => {
                      this.setState({ type: "batch", step: 0 });
                    }}
                  >
                    {this.state.type === "batch" && (
                      <img
                        src={
                          require("../../../assets/imgs/ico-transfer-white.svg")
                            .default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {this.state.type !== "batch" && (
                      <img
                        src={
                          require("../../../assets/imgs/ico-transfer-green.svg")
                            .default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {"Batch payments"}
                  </div>
                )}

                {!isVoluti() && (
                  <div
                    className={
                      "contentButtonPix " +
                      (this.state.type === "copyAndPaste"
                        ? "contentButtonPixSelected"
                        : "")
                    }
                    onClick={() => {
                      this.setState({ type: "copyAndPaste", step: 0 });
                    }}
                  >
                    {this.state.type === "copyAndPaste" && (
                      <img
                        src={
                          require("../../../assets/imgs/ico-copy-paste.svg")
                            .default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {this.state.type !== "copyAndPaste" && (
                      <img
                        src={
                          require("../../../assets/imgs/ico-copy-paste.svg")
                            .default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {this.state.translations.copyAndPaste}
                  </div>
                )}

                {
                  // !isMutual() &&
                  // !isVoluti() &&
                  // <div className={"contentButtonPix " + (this.state.type==="bankData"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "bankData", step: 0})}}>
                  //     {
                  //       this.state.type==="bankData" &&
                  //       <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                  //     }
                  //     {
                  //       this.state.type!=="bankData" &&
                  //       <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                  //     }
                  //     {this.state.translations.bankData}
                  //   </div>
                }

                {!isMutual() && !isVoluti() && (
                  <div
                    className={
                      "contentButtonPix " +
                      (this.state.type === "qrCode"
                        ? "contentButtonPixSelected"
                        : "")
                    }
                    onClick={() => {
                      this.setState({ type: "qrCode", step: 0 });
                    }}
                  >
                    {this.state.type === "qrCode" && (
                      <img
                        src={
                          require("../../../assets/imgs/qr-code.svg").default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {this.state.type !== "qrCode" && (
                      <img
                        src={
                          require("../../../assets/imgs/qr-code.svg").default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {this.state.translations.qrCode}
                  </div>
                )}
                {
                  //  <div className={"contentButtonPix " + (this.state.type==="pixLimits"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "pixLimits", step: 0})}}>
                  //    {
                  //      this.state.type==="pixLimits" &&
                  //      <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                  //    }
                  //    {
                  //      this.state.type!=="pixLimits" &&
                  //      <img src={require("../../../assets/imgs/ico-settings-green.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                  //    }
                  //    {this.state.translations.pixLimits}
                  //  </div>
                }
                {!isMtBank() && (
                  <div
                    className={
                      "contentButtonPix " +
                      (this.state.type === "pixKey"
                        ? "contentButtonPixSelected"
                        : "")
                    }
                    onClick={() => {
                      this.setState({ type: "pixKey", step: 0 });
                    }}
                  >
                    {this.state.type === "pixKey" && (
                      <img
                        src={
                          require("../../../assets/imgs/ico-key.svg").default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                        style={{ filter: "brightness(0) invert(1)" }}
                      />
                    )}
                    {this.state.type !== "pixKey" && (
                      <img
                        src={
                          require("../../../assets/imgs/ico-key-green.svg")
                            .default
                        }
                        alt={this.state.translations.iconMenu}
                        className="iconPix"
                      />
                    )}
                    {this.state.translations.pixKey}
                  </div>
                )}

                <PixTransfer
                  type={this.state.type}
                  step={this.state.step}
                  onChangeValue={this.onChangeValue}
                />
              </div>

              <Footer />
            </div>
          </div>
        </span>

        <span className="mobile">
          <div className="contentData">
            <div className="contentScroll">
              <div
                style={{
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span>{this.state.translations.currentBalance}</span>
                <span style={{ fontSize: "20px" }}>
                  <b>
                    {this.state.viewBalance
                      ? Number(
                          this.state.valueBalance.toFixed(2),
                        ).toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })
                      : "**********"}{" "}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </b>
                  {this.state.viewBalance && (
                    <img
                      src={require("../../../assets/imgs/open-eye.svg").default}
                      style={{ display: "inline-block", cursor: "pointer" }}
                      alt={this.state.translations.iconViewBalance}
                      onClick={() => {
                        this.setState({ viewBalance: false });
                      }}
                    />
                  )}
                  {!this.state.viewBalance && (
                    <img
                      src={
                        require("../../../assets/imgs/close-eye.svg").default
                      }
                      style={{
                        border: "3px solid rgba(0,0,0,0)",
                        display: "inline-block",
                        cursor: "pointer",
                      }}
                      alt={this.state.translations.iconViewBalance}
                      onClick={() => {
                        this.setState({ viewBalance: true });
                      }}
                    />
                  )}
                </span>
              </div>

              <p className="title">
                {this.state.translations.transfers} |
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  {this.state.translations.pix}
                </span>
              </p>
              <br />

              <div className="contentSubData">
                <div className="scroll">
                  <div className="contentButtons">
                    <div
                      className={
                        "contentButtonPix " +
                        (this.state.type === "pixTransfer"
                          ? "contentButtonPixSelected"
                          : "")
                      }
                      onClick={() => {
                        this.setState({ type: "pixTransfer", step: 0 });
                      }}
                    >
                      {this.state.type === "pixTransfer" && (
                        <img
                          src={
                            require("../../../assets/imgs/ico-transfer-white.svg")
                              .default
                          }
                          alt={this.state.translations.iconMenu}
                          className="iconPix"
                        />
                      )}
                      {this.state.type !== "pixTransfer" && (
                        <img
                          src={
                            require("../../../assets/imgs/ico-transfer-green.svg")
                              .default
                          }
                          alt={this.state.translations.iconMenu}
                          className="iconPix"
                        />
                      )}
                      {this.state.translations.pixTransfer}
                    </div>

                    {isMtBank() && (
                      <div
                        className={
                          "contentButtonPix " +
                          (this.state.type === "batch"
                            ? "contentButtonPixSelected"
                            : "")
                        }
                        onClick={() => {
                          this.setState({ type: "batch", step: 0 });
                        }}
                      >
                        {this.state.type === "batch" && (
                          <img
                            src={
                              require("../../../assets/imgs/ico-transfer-white.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                          />
                        )}
                        {this.state.type !== "batch" && (
                          <img
                            src={
                              require("../../../assets/imgs/ico-transfer-green.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                          />
                        )}
                        {"Batch payments"}
                      </div>
                    )}

                    {!isVoluti() && (
                      <div
                        className={
                          "contentButtonPix " +
                          (this.state.type === "copyAndPaste"
                            ? "contentButtonPixSelected"
                            : "")
                        }
                        onClick={() => {
                          this.setState({ type: "copyAndPaste", step: 0 });
                        }}
                      >
                        {this.state.type === "copyAndPaste" && (
                          <img
                            src={
                              require("../../../assets/imgs/ico-copy-paste.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                            style={{ filter: "brightness(0) invert(1)" }}
                          />
                        )}
                        {this.state.type !== "copyAndPaste" && (
                          <img
                            src={
                              require("../../../assets/imgs/ico-copy-paste.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                          />
                        )}
                        {this.state.translations.copyAndPaste}
                      </div>
                    )}

                    {
                      // !isMutual() &&
                      // !isVoluti() &&
                      // <div className={"contentButtonPix " + (this.state.type==="bankData"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "bankData", step: 0})}}>
                      //     {
                      //       this.state.type==="bankData" &&
                      //       <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                      //     }
                      //     {
                      //       this.state.type!=="bankData" &&
                      //       <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                      //     }
                      //     {this.state.translations.bankData}
                      //   </div>
                    }

                    {!isMutual() && !isVoluti() && (
                      <div
                        className={
                          "contentButtonPix " +
                          (this.state.type === "qrCode"
                            ? "contentButtonPixSelected"
                            : "")
                        }
                        onClick={() => {
                          this.setState({ type: "qrCode", step: 0 });
                        }}
                      >
                        {this.state.type === "qrCode" && (
                          <img
                            src={
                              require("../../../assets/imgs/qr-code.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                            style={{ filter: "brightness(0) invert(1)" }}
                          />
                        )}
                        {this.state.type !== "qrCode" && (
                          <img
                            src={
                              require("../../../assets/imgs/qr-code.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                          />
                        )}
                        {this.state.translations.qrCode}
                      </div>
                    )}
                    {
                      //  <div className={"contentButtonPix " + (this.state.type==="pixLimits"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "pixLimits", step: 0})}}>
                      //    {
                      //      this.state.type==="pixLimits" &&
                      //      <img src={require("../../../assets/imgs/ico-transfer-white.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                      //    }
                      //    {
                      //      this.state.type!=="pixLimits" &&
                      //      <img src={require("../../../assets/imgs/ico-settings-green.svg").default} alt={this.state.translations.iconMenu} className="iconPix"/>
                      //    }
                      //    {this.state.translations.pixLimits}
                      //  </div>
                    }
                    {!isMtBank() && (
                      <div
                        className={
                          "contentButtonPix " +
                          (this.state.type === "pixKey"
                            ? "contentButtonPixSelected"
                            : "")
                        }
                        onClick={() => {
                          this.setState({ type: "pixKey", step: 0 });
                        }}
                      >
                        {this.state.type === "pixKey" && (
                          <img
                            src={
                              require("../../../assets/imgs/ico-key.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                            style={{ filter: "brightness(0) invert(1)" }}
                          />
                        )}
                        {this.state.type !== "pixKey" && (
                          <img
                            src={
                              require("../../../assets/imgs/ico-key-green.svg")
                                .default
                            }
                            alt={this.state.translations.iconMenu}
                            className="iconPix"
                          />
                        )}
                        {this.state.translations.pixKey}
                      </div>
                    )}
                  </div>
                </div>

                <PixTransfer
                  type={this.state.type}
                  step={this.state.step}
                  onChangeValue={this.onChangeValue}
                />
              </div>

              <Footer />
            </div>
          </div>
        </span>
        <ToastContainer />
      </section>
    );
  }
}

export default Item;
